import React from 'react'
import { observer } from 'mobx-react'
import { SingleSelectFilter } from '../../../../infra/FilterControls/SingleSelect/SingleSelectFilter'
import { WorkspacePostingStatusFilter } from '../StaffingTable/StaffingSearchViewModel'
import cx from 'classnames'
import { Card, CardContent } from '../../../../components/Card'
import styles from './WorkspacePostingStatusFilter.sass'

interface WorkspacePostingStatusFilterProps<
  TFilters extends Record<string, unknown>
> {
  filter: SingleSelectFilter<keyof TFilters, WorkspacePostingStatusFilter>
}
export default observer(function StaffingHeader<
  TFilters extends Record<string, unknown>
>({ filter }: WorkspacePostingStatusFilterProps<TFilters>) {
  return (
    <div className={styles.root}>
      <h1>{filter.title}</h1>
      <div className={styles.cardsContainer}>
        {filter.options.map((opt) => (
          <WorkspacePostingFilterCard
            key={opt.value.type}
            title={opt.title}
            option={opt.value}
            filter={filter}
          />
        ))}
      </div>
    </div>
  )
})

interface WorkspacePostingStatusFilterCardProps<
  TFilters extends Record<string, unknown>
> {
  title: string
  option: WorkspacePostingStatusFilter
  filter: SingleSelectFilter<keyof TFilters, WorkspacePostingStatusFilter>
}

const WorkspacePostingFilterCard = observer(function StaffingFilterCard<
  TFilters extends Record<string, unknown>
>({ title, option, filter }: WorkspacePostingStatusFilterCardProps<TFilters>) {
  return (
    <button
      className={cx(
        styles.filterCardContainer,
        filter.value.type === option.type && styles.active
      )}
      onClick={() => filter.change(option)}
    >
      <Card borderless>
        <CardContent compact>
          <div
            className={cx(
              styles.filterCardContent,
              styles[`requestVariant-${option.type}`]
            )}
          >
            <h2>{title}</h2>
            <h1>{option.count}</h1>
          </div>
        </CardContent>
      </Card>
    </button>
  )
})
